module.exports = __webpack_public_path__ + "static/img/bg_3_4.0399737.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_3_4.png
// module id = RYR3
// module chunks = 3